import get from "lodash/get";
import moment from "moment";
import orderby from "lodash/orderBy";
import sortby from "lodash/sortBy";

export function filterObjArrWithIntArr({ arrObj, objKey, arrIds }) {
  return arrObj.filter((x) => arrIds.findIndex((y) => y == x[objKey]) != -1);
}

export function new1() {
  return 5;
}

export function getOptArr({
  arr = [],
  displaynamekey = "displayname",
  displayvaluekey = "displayvalue",
  disabledkey = "disabled",
}) {
  if (!Array.isArray(arr)) return;
  return arr.map((element) => ({
    ...element,
    displayname: element[displaynamekey],
    displayvalue: element[displayvaluekey],
    disabled: element[disabledkey],
  }));
}

export function getDisplayValueFromArray(name, arr = [], key = "displayname") {
  // console.log('arr: ', arr);
  // console.log('name: ', name);
  if (arr[0] && name) {
    const res1 = arr.find((x) => x[key] === name);
    const res = res1 ? res1.displayvalue : null;
    console.log('res: ', res);
    return res;
  }
  return null;
}

export function getDisplayNameFromArray(name, arr = [], key = "displayname") {
  if (arr && arr[0] && name) {
    const res1 = arr.find((x) => x[key] == name);
    const res = res1 ? res1.displayname : null;
    return res;
  }
  return null;
}

export function getDisplayValueFromTwoLevelArray(name, arr) {
  if (arr[0] && name) {
    let res = null;
    arr.forEach((x) => {
      get(x, "options", []).forEach((y) => {
        if (y.label == name) {
          res = y.value;
        }
      });
    });
    return res;
  }
  return null;
}

export function getDisplayNameFromTwoLevelArray(name, arr) {
  if (arr[0] && name) {
    let res = null;
    arr.forEach((x) => {
      get(x, "options", []).forEach((y) => {
        if (y.label == name) {
          res = y.label;
        }
      });
    });
    return res;
  }
  return null;
}

export function sortArrByDate({ arr = [], datekey = "date", asc = true }) {
  if (asc) {
    const sortedArray = arr
      .sort(
        (a, b) =>
          moment(a[datekey], "YYYY-MM-DD hh:mm:ss").valueOf()
          - moment(b[datekey], "YYYY-MM-DD hh:mm:ss").valueOf(),
      )
      .reverse();
    return sortedArray;
  } else if (!asc) {
    const sortedArray = sortby(arr, (o) =>
      moment(o[datekey], "YYYY-MM-DD hh:mm:ss").valueOf()).reverse();
    return sortedArray;
  }
}

export function sortByGivenKey({ arr = [], key = "name", asc = true }) {
  if (asc) {
    const sortedArray = arr.sort((a, b) => {
      if (a[key].toLowerCase() > b[key].toLowerCase()) {
        return 1;
      }
      if (a[key].toLowerCase() < b[key].toLowerCase()) {
        return -1;
      }
      return 0;
    });
    return sortedArray;
  } else if (!asc) {
    const sortedArray = arr.sort((a, b) => {
      if (a[key].toLowerCase() > b[key].toLowerCase()) {
        return -1;
      }
      if (a[key].toLowerCase() < b[key].toLowerCase()) {
        return 1;
      }
      return 0;
    });
    return sortedArray;
  }
}

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export function getNumberValidation(value) {
  var re = /^[A-Za-z0-9]+$/;
  if (value === '' || re.test(value)) {
    return true;
  }
  else {
    return false;
  }
}

export function getTaxgroupMastertaxgroup(name, arr = [], isTaxgroup ,key = "displayname") {
  console.log('arr: ', arr);
  console.log('name: ', name);
  if (arr[0] && name) {
    const res1 = arr.find((x) => x[key] === name);
    const res = res1 && isTaxgroup ? res1.taxgroupheadid : res1.mastertaxgroupid;
    console.log('res: ', res);
    return res;
  }
  return null;
}
